import { useEffect, useContext, useRef, RefObject } from 'react'
import { AppContext } from 'contexts/AppProvider'

interface FirstParamObjectType {
  pageName: string
  scrollPageRef?: RefObject<HTMLElement>
  skip?: boolean
}

const useScrollTopPage = (
  firstParam: string | FirstParamObjectType,
  scrollPageRef?: RefObject<HTMLElement>,
  skip = false
) => {
  let _pageName = firstParam
  let _scrollPageRef = scrollPageRef
  let _skip = skip

  if (typeof firstParam === 'object') {
    _pageName = firstParam.pageName
    _scrollPageRef = firstParam.scrollPageRef
    _skip = firstParam.skip ?? false
  }

  const timerSetScrollTop = useRef<ReturnType<typeof setTimeout>>()

  const { scrollTopPages, setScrollTopPages } = useContext(AppContext)

  function setScrollTopPage(pageName, scrollTop) {
    let _scrollTopPages = scrollTopPages
    _scrollTopPages[pageName] = scrollTop
    setScrollTopPages(_scrollTopPages)
  }

  function getScrollTopPage(pageName) {
    return scrollTopPages[pageName]
  }

  useEffect(() => {
    if (_scrollPageRef && _scrollPageRef.current instanceof HTMLElement) {
      if (!_skip && typeof _scrollPageRef.current.scrollTo === 'function') {
        _scrollPageRef.current.scrollTo(0, getScrollTopPage(_pageName))
      } else {
        _scrollPageRef.current.addEventListener('scroll', () => {
          if (timerSetScrollTop.current) {
            clearTimeout(timerSetScrollTop.current)
          }
          timerSetScrollTop.current = setTimeout(() => {
            if (_scrollPageRef?.current) {
              setScrollTopPage(_pageName, _scrollPageRef.current.scrollTop)
            }
          }, 100)
        })
      }
    }
  }, [_scrollPageRef, _skip])

  return {
    getCurrentScrollTop: () => getScrollTopPage(_pageName),
    setScrollTopPage,
  }
}

export default useScrollTopPage
